var map = {
	"./de/more-btn.png": "QKw1",
	"./en/more-btn.png": "5nLU",
	"./es/more-btn.png": "F52i",
	"./fr/more-btn.png": "MLb4",
	"./ja/more-btn.png": "Cmry",
	"./ko/more-btn.png": "Ab0w",
	"./pt/more-btn.png": "2Em5",
	"./ru/more-btn.png": "7gbv",
	"./tc/more-btn.png": "oUMo",
	"./th/more-btn.png": "idBW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WS65";